import { useTranslation } from 'react-i18next';

export default function VillaflorCTA() {
  const { t } = useTranslation();

  return (
    <section className="relative py-24 md:py-36 px-4 md:px-10 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/f11cd3cf-6b55-4cb4-bc65-73427384328d/b38713ff-c51d-4ef1-a7fc-7831879958fa_compressed_barbacoa-.webp"
          alt="Casa De la Villaflor outdoor BBQ area with grill and terrace"
          title="Casa De la Villaflor - BBQ Area"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center text-white">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
          {t('cta_villaflor_title')}
        </h2>
        <p className="text-base md:text-lg text-white/80 mb-8 font-light">
          {t('cta_villaflor_subtitle')}
        </p>
        <a
          href="#search"
          className="inline-block bg-primary-500 hover:bg-primary-600 text-white px-10 py-4 rounded-md text-base md:text-lg font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer hover:scale-105 transform"
        >
          {t('cta_reserve')}
        </a>
      </div>
    </section>
  );
}